import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';

import Icons from '../Icons';
import toast from 'react-hot-toast';

export default function AuthPage({ onSuccess }) {
  const navigate = useNavigate();
  const { googleSignIn, emailSignUp, emailSignIn } = useAuth();

  const [mode, setMode] = useState('login');
  const [email, setEmail] = useState('');
  const [pass, setPass] = useState('');
  const [confirmPass, setConfirmPass] = useState('');
  const [loading, setLoading] = useState(false);

  const validateGmail = (em) => {
    if (!em) return 'Email is required';
    if (!em.endsWith('@gmail.com')) return 'Only @gmail.com accounts are allowed';
    const localPart = em.replace('@gmail.com', '');
    if (localPart.length < 3) return 'Invalid email address';
    return null;
  };

  const handleGoogle = async () => {
    try {
      setLoading(true);
      await googleSignIn();
      toast.success('Welcome!');
      if (onSuccess) onSuccess();
    } catch (err) {
      const msg = err.message || '';
      if (msg.includes('gmail')) toast.error('Only @gmail.com accounts are allowed');
      else toast.error('Sign in failed');
    } finally {
      setLoading(false);
    }
  };

  const handleEmail = async (e) => {
    e.preventDefault();

    // Validate gmail
    const emailErr = validateGmail(email);
    if (emailErr) { toast.error(emailErr); return; }

    if (!pass || pass.length < 6) { toast.error('Password must be at least 6 characters'); return; }

    // Confirm password for signup
    if (mode === 'signup') {
      if (!confirmPass) { toast.error('Please confirm your password'); return; }
      if (pass !== confirmPass) { toast.error('Passwords do not match'); return; }
    }

    setLoading(true);
    try {
      if (mode === 'signup') {
        await emailSignUp(email, pass);
        toast.success('Account created!');
      } else {
        await emailSignIn(email, pass);
        toast.success('Welcome back!');
      }
      if (onSuccess) onSuccess();
    } catch (err) {
      const msg = err.message || '';
      toast.error(
        msg.includes('gmail') ? 'Only @gmail.com accounts are allowed' :
        msg.includes('email-already') ? 'Email already in use' :
        msg.includes('wrong-password') ? 'Wrong password' :
        msg.includes('user-not-found') ? 'No account found' :
        msg.includes('invalid-credential') ? 'Invalid email or password' :
        'Authentication failed'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-inner">
      <div className="auth-logo" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
        <img src="/logo.png" alt="aiField logo" style={{ height: 36, width: 'auto' }} />
      </div>
      <p className="auth-sub">
        Create stunning images & videos with cutting-edge AI models.<br />
        Start free with 10 credits.
      </p>

      <button className="abtn" onClick={handleGoogle} disabled={loading}>
        <Icons.Gemini sz={18} /> Continue with Google
      </button>

      <div className="auth-div">or use @gmail.com email</div>

      <form onSubmit={handleEmail}>
        <input className="auth-in" type="email" placeholder="your-email@gmail.com"
          value={email} onChange={e => setEmail(e.target.value)} />
        <input className="auth-in" type="password" placeholder="Password (min 6 characters)"
          value={pass} onChange={e => setPass(e.target.value)} />

        {/* Confirm Password — signup only */}
        {mode === 'signup' && (
          <input className="auth-in" type="password" placeholder="Confirm password"
            value={confirmPass} onChange={e => setConfirmPass(e.target.value)}
            style={{ marginTop: 8 }} />
        )}

        <button className="abtn pri" type="submit" disabled={loading} style={{ marginTop: 12 }}>
          {loading ? <div className="spinner" /> : mode === 'signup' ? 'Create Account' : 'Sign In'}
        </button>
      </form>

      <div style={{ fontSize: 10, color: 'var(--or)', textAlign: 'center', marginTop: 4 }}>
        ⚠️ Only @gmail.com accounts are supported
      </div>

      <div className="atog">
        {mode === 'login' ? (
          <>No account? <span onClick={() => { setMode('signup'); setConfirmPass(''); }}>Sign up</span></>
        ) : (
          <>Have account? <span onClick={() => setMode('login')}>Sign in</span></>
        )}
      </div>
      <p className="anote">By signing in you agree to our <span onClick={() => navigate('/privacy')} style={{ cursor: 'pointer', textDecoration: 'underline' }}>Terms of Service and Privacy Policy</span>.</p>

    </div>
  );
}
